import apiDtMood from './dtMoodApiHandler'
import { getDtMoodSession } from './dtmood-session.service'

const getCategories = () => {
  const dtMoodSession = getDtMoodSession()
  const clientId = dtMoodSession ? dtMoodSession.clientId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/feedback-categories/client/${clientId}`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const getSubCategories = (categoryId) => {
  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/feedback-subcategories?categoryId=${categoryId}`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const getDepartments = () => {
  const dtMoodSession = getDtMoodSession()
  const clientId = dtMoodSession ? dtMoodSession.clientId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/departments/client/${clientId}`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getCategories, getSubCategories, getDepartments }
